import { combineReducers } from 'redux';

import corporateSignupReducer from './corporateSignupReducer';

export default combineReducers({
    corporateSignupReducer
});
